/**
 * @file Map-marker-confirm-delete.tsx
 * @module MapMarkerConfirmDelete
 * @description Dzēšanas apstiprinājuma dialoglodziņš marķieru komponentam.
 *              Parāda "Tiešām dzēst?" apstiprinājumu pirms marķiera noņemšanas
 *              no kartes slāņa.
 */
import { CloseOutlined } from "@ant-design/icons";
import { Button } from "antd";

interface Props {
	onClose: () => void;
	onDelete: () => void;
}

export const MapMarkerConfirmDelete = (props: Props) => {
	return (
		<section className="w-[618px] min-h-[120px] bg-white rounded-md shadow-md py-4 px-6 gap-4 flex flex-col justify-between">
			<header className="font-medium flex items-center justify-between">
				<h4 className="text-lg">Tiešām dzēst?</h4>
				<button onClick={props.onClose}>
					<CloseOutlined rev={undefined} />
				</button>
			</header>
			<div className="flex col-span-4 justify-end gap-2">
				<Button onClick={props.onClose}>Atcelt</Button>
				<Button onClick={props.onDelete} type="primary">
					Dzēst
				</Button>
			</div>
		</section>
	);
};
